/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable max-len */
export const deploymentGuideMessages = {
    'deploymentGuide.discoveryPhase': 'Deploy & Discover',
    'deploymentGuide.discoveryPhaseSummary':
        'For the best Auvik SaaS Management experience, be sure to complete all the essential setup steps.',

    'deploymentGuide.discovery.AD.name':
        'Set up Identity Management Integration',
    'deploymentGuide.discovery.AD.description':
        'Microsoft Entra ID or Google Workspace.',
    'deploymentGuide.discovery.Access.name': 'Grant Dashboard Access',
    'deploymentGuide.discovery.Access.description':
        'Assign users access to this portal.',
    'deploymentGuide.discovery.Access.tooltip':
        'This option is primarily for non-IT employees and will only grant access to this specific deployment. To allow a user to access multiple tenants, add them under the Partner Hub > Org Preferences > Manage Users menu.',
    'deploymentGuide.discovery.Deploy.name': 'Deploy SaaS Discovery Agent',
    'deploymentGuide.discovery.Deploy.description':
        'Deploy the Auvik SaaS Discovery Agent to your users.',

    'deploymentGuide.managementPhase': 'Manage & Govern',
    'deploymentGuide.managementPhaseSummary':
        'Determine which applications are under management, establish their respective lifecycle stages, and designate responsible business owners.',

    'deploymentGuide.management.ReviewSsoStatus.name': 'Review SSO Status',
    'deploymentGuide.management.ReviewSsoStatus.description':
        'Review SSO usage and identify opportunities to improve security posture.',
    'deploymentGuide.management.Classification.name':
        'Organize and Classify Applications',
    'deploymentGuide.management.Classification.description':
        'Decide what applications are managed.',
    'deploymentGuide.management.LifecycleStage.name':
        'Set Application Lifecycle Stages',
    'deploymentGuide.management.LifecycleStage.description':
        'Identify approved and unapproved applications.',
    'deploymentGuide.management.BusinessOwner.name':
        'Assign Responsibility and Business Owners',
    'deploymentGuide.management.BusinessOwner.description':
        'Assign business ownership and responsibility of managed applications.',

    'deploymentGuide.optimizationPhase': 'Analyze & Remediate',
    'deploymentGuide.optimizationPhaseSummary':
        'Manage tasks like scheduling automated reports, assigning offboard ownership for application lifecycle stages, and choosing recipients for ShadowIT notifications.',
    'deploymentGuide.title': 'Deployment Guide',

    'deploymentGuide.optimization.AutomatedReports.name':
        'Run and Schedule Automated Reports',
    'deploymentGuide.optimization.AutomatedReports.description':
        'Schedule reports.',
    'deploymentGuide.optimization.OffboardWorkflow.name':
        'Run an Offboard Report',
    'deploymentGuide.optimization.OffboardWorkflow.description':
        'Assign offboard ownership.',
    'deploymentGuide.optimization.ShadowIT.name': 'Configure ShadowIT Alerts',
    'deploymentGuide.optimization.ShadowIT.description':
        'Assign who should receive ShadowIT notifications.',
    'deploymentGuide.optimization.setupAlerts.name': 'Setup Alerts',
    'deploymentGuide.optimization.reviewVendorIncidents.name':
        'Review Vendor Incident',
    'deploymentGuide.optimization.createCustomTags.name': 'Create Custom Tags',
    'deploymentGuide.optimization.onboardEmployee.name': 'Onboard an Employee',

    'onboarding.skip': 'Skip onboarding',
    'onboarding.agent': 'Deploy SaaS Discovery Agent',
    'onboarding.identityManagement': 'Set up Identity Management Integration',
    'onboarding.SaasOps': 'Configure SaaS Ops Integration'
};
